import { useEffect, useRef, useState } from "react";
import { getEslTempProductDetailAsync } from "src/api/esl/esl-api";
import { useApiOperation } from "src/api/hooks";
import { BaseTooltip } from "src/components";
import useIntersectionObserver from "src/hooks/useIntersectionObserver";

const Esl = ({ row }: any) => {
  const { executeAsync: getEslTempProductDetail } = useApiOperation(getEslTempProductDetailAsync, {
    noErrorModal: true,
    noLoading: true,
  });
  const [labelCode, setLabelCode] = useState<string | undefined>();
  const target = useRef(null);

  const { observe } = useIntersectionObserver(
    async () => {
      const locationCode = row?.original?.locationCode as string;

      try {
        if (locationCode) {
          // serverId2 먼저 조회
          const { data: esl2 } = await getEslTempProductDetail({ productId: locationCode, serverId: "2" });

          const assignedLabelCodes2 = esl2?.data?.product?.assignedLabelCodes?.join(",");

          // serverId2 조회 결과가 있으면 setState 후 리턴 (조회 종료)
          if (assignedLabelCodes2) {
            setLabelCode(assignedLabelCodes2);
            return;
          }

          // serverId2 조회 결과가 없으면 setState 후 리턴 (조회 종료)
          setLabelCode("");
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    { threshold: 0.3 }, //0.3 퍼센트만 노출되면 콜백 실행
  );

  useEffect(() => {
    observe(target.current);
  }, []);

  return (
    <div className="ellipsis2" ref={target}>
      <BaseTooltip contents={labelCode || "-"} />
    </div>
  );
};

export default Esl;
